import { ApolloError, ApolloQueryResult, gql, useQuery } from '@apollo/client'
import type { GetSecretIdAndBeenViewedByShortIdQuery, Query } from 'apollo-gql'
import { currentMarketIdVar } from 'graphql/reactive'

import useCurrentUser from './useCurrentUser'

export const GET_SECRETID_AND_BEEN_VIEWED_BY_SHORTID = gql`
  query GetSecretIdAndBeenViewedByShortId(
    $marketId: ID!
    $shortId: ID
    $requestId: ID
  ) {
    market(id: $marketId) {
      id
      review(shortId: $shortId) {
        secretId
        status
      }
    }
    requestBeenViewed(requestId: $requestId)
  }
`
type useReviewForRequestProps = {
  shortId: string
  requestId: string
}

type useReviewForRequestResult = {
  review: GetSecretIdAndBeenViewedByShortIdQuery['market']['review']
  beenViewed: boolean
  loading: boolean
  error: ApolloError
  refetch: () => Promise<ApolloQueryResult<Query>> | false
}
const useReviewForRequest = ({
  shortId,
  requestId,
}: useReviewForRequestProps): useReviewForRequestResult => {
  const marketId = currentMarketIdVar()
  const { currentUser } = useCurrentUser()
  const skip = !currentUser ?? true

  const {
    data = {},
    error,
    loading,
    refetch,
  } = useQuery(GET_SECRETID_AND_BEEN_VIEWED_BY_SHORTID, {
    skip,
    variables: { marketId, shortId, requestId },
  })
  const beenViewed = data?.requestBeenViewed || false
  const review = data?.market?.review

  return {
    review,
    beenViewed,
    loading,
    error,
    refetch: !skip && refetch,
  }
}

export default useReviewForRequest
